module.exports = __webpack_public_path__ + "static/media/polar-mint2@3x.d6b7cc4c.png";